/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {

  class Pagination extends HTMLElement {

    constructor() {
      super();

      const id = this.dataset.section;

      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');

      this.animations_enabled =
        document.body.classList.contains('animations-true') &&
        typeof gsap !== 'undefined';

      this.i = 2;
    }

    connectedCallback() {

      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }

      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    addUrlParam(search, key) {

      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {

        params = search.replace(
          new RegExp('([?&])' + key + '[^&]*'),
          '$1' + newParam
        );

        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }

    loadMore() {

      let base = this;

      this.button.addEventListener('click', function () {

        base.loadProducts();

        this.blur();

        return false;
      });
    }

    infinite() {

      let base = this;

      base.observer = new IntersectionObserver(function (entries) {

        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }

      }, {
        threshold: [0, 1]
      });

      base.observer.observe(base);
    }

    loadProducts() {

      let base = this,
        url =
          document.location.pathname +
          base.addUrlParam(document.location.search, 'page');

      if (base.getAttribute('loading')) {
        return;
      }

      base.i++;

      base.setAttribute('loading', true);

      fetch(url)
        .then(response => response.text())
        .then((responseText) => {

          const html = responseText;

          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });

        });
    }

    renderProducts(html, url) {

      let base = this,
        parsedHTML = new DOMParser()
          .parseFromString(html, 'text/html'),
        grid_to_replace = parsedHTML.getElementById('product-grid');

      // NO MORE PRODUCTS
      if (!grid_to_replace) {

        // SHOW SOLD OUT PRODUCTS
        document.querySelectorAll('.hidden-sold-out').forEach((product) => {

          product.style.opacity = '1';
          product.style.visibility = 'visible';
          product.style.pointerEvents = 'auto';
          product.style.position = 'relative';

        });

        if (base.observer) {
          base.observer.unobserve(base);
        }

        base.removeAttribute('loading');

        if (base.button) {
          base.button.classList.add('visually-hidden');
        }

        return;
      }

      // ONLY PRODUCT ITEMS
      let products = grid_to_replace.querySelectorAll('li.column');

      let inStock = [];
      let soldOut = [];

      // SPLIT PRODUCTS
      products.forEach((product) => {

        let soldBadge =
          product.querySelector('.sold-out') ||
          product.querySelector('.badge--soldout') ||
          product.textContent.toLowerCase().includes('sold out');

        if (soldBadge) {
          soldOut.push(product);
        } else {
          inStock.push(product);
        }

      });

      // APPEND IN STOCK PRODUCTS
      inStock.forEach((product) => {

        base.grid.appendChild(product);

        product.querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });

      });

      // APPEND SOLD OUT PRODUCTS HIDDEN
      soldOut.forEach((product) => {

        product.classList.add('hidden-sold-out');

        product.style.order = '999';
        product.style.opacity = '0';
        product.style.visibility = 'hidden';
        product.style.pointerEvents = 'none';
        product.style.position = 'absolute';

        base.grid.appendChild(product);

        product.querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });

      });

      // ANIMATIONS
      if (this.animations_enabled) {

        gsap.set(products, {
          opacity: 0,
          y: 30
        });

        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });

      } else {

        base.removeAttribute('loading');
      }
    }
  }

  customElements.define('pagination-theme', Pagination);
}